import get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'shared/lib';
import { sendSentryFlowError } from 'shared/lib/sendSentryFlowError';
import { useClickLock } from 'shared/lib/useClickLock';
import { PageHeader } from 'shared/ui/PageHeader';

import { goToNextScenarioThunk } from 'entities/scenario';
import { accountSelector } from 'entities/user';

import type { NavigationHeaderCommonProps, ScenarioWithContentHeader } from '../types';

type NavigationHeaderProps = NavigationHeaderCommonProps & {
  scenario: ScenarioWithContentHeader;
};

export const NavigationHeader = ({ className, returnUrl, scenario }: NavigationHeaderProps) => {
  const { content, step } = scenario;
  const user = useSelector(accountSelector);
  const dispatch = useAppDispatch();
  const { runLocked } = useClickLock();

  const { header } = content;

  const goBack = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
      return;
    }

    const path = 'header.onClick.action';
    const action = get(content, path);

    if (!action) {
      sendSentryFlowError({ path, step, payload: { userId: user?.sub } });
    }

    runLocked(async () => {
      await dispatch(goToNextScenarioThunk({ ...action })).unwrap();
    });
  };

  return (
    <PageHeader
      className={className}
      size={14}
      onClick={goBack}
      title={header.title}
    />
  );
};
